import Inputmask from 'inputmask';
import { Calendar } from 'primeng/calendar';

import { AfterViewInit, Directive } from '@angular/core';

@Directive({
  selector: '[dateMask]'
})
export class DateMaskDirective implements AfterViewInit {
  constructor(private primeCalendar: Calendar) { }

  ngAfterViewInit() {
    new Inputmask( this.getDateMask() ).mask( this.getHTMLInput() );
    if (this.primeCalendar.timeOnly) {
      window.setTimeout(() => {
        this.primeCalendar.inputfieldViewChild.nativeElement.focus();
      }, 10);
    }
  }

  getHTMLInput(): HTMLInputElement {
    return this.primeCalendar.el.nativeElement.querySelector('input');
  }

  getDateMask(): string {
    if(this.primeCalendar.timeOnly) {
      return '99:99:99';
    } else if(this.primeCalendar.showTime) {
      return '99.99.9999 99:99';
    } else {
      return '99.99.9999';
    }
  }
}